import React, { useState } from "react";
import styled from "styled-components";
import { FaFileImage, FaTimes } from "react-icons/fa"; // Import the delete icon
import Icon from "../../Images/Icon.svg";
import { fileToBase64 } from "../../utilities/fileToBase64";
import UploadedImage from "../UploadedImagedComponent/UploadedImage";
import { useLanguage } from "../LangTranslation/LanguageContext";

const Container = styled.div`
  // margin: 50px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const UploadContainer = styled.div`
  border: 2px dashed #cbcbcb;
  padding: 20px;
  display: flex;
  background-color: #f5f5f5;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 90%;
  height: 350px;
  padding: 20px;
  border-radius: 15px;
  position: relative;
  @media (max-width: 767.98px) {
    width: 100%;
    height: 200px;
  }
`;

const IconContainer = styled.div`
  font-size: 160px;
  color: #ccc;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
`;

const Text = styled.p`
  font-family: "Comfortaa";
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  .upload_span {
    color: #ff5837;
  }
`;

const DeleteIcon = styled(FaTimes)`
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  color: red;
  cursor: pointer;
`;

const ProductImages = ({ disabled, setFieldValue, values }) => {
  const handleSetUploadedImageBase64 = (_, base64) => {
    setFieldValue("social_image_1920", base64);
  };
  const handleImageUpload = (e) => {
    const selectedFiles = e.target.files[0];
    fileToBase64(selectedFiles, handleSetUploadedImageBase64);
  };

  const handleDeleteImage = () => {
    if (disabled) return;

    setFieldValue("social_image_1920", "");
  };

  const { language, translations } = useLanguage();
  const t = translations[language];
  return (
    <Container>
      <UploadContainer>
        {values.social_image_1920 ? (
          <>
            <UploadedImage src={values.social_image_1920 || ""} />
            <DeleteIcon onClick={handleDeleteImage} />
          </>
        ) : (
          <label htmlFor="fileInput">
            <IconContainer>
              <img src={Icon} alt="image preview" />
            </IconContainer>
            <Text>
              <span className="upload_span">{t["Upload"]} </span>
              {t["product images or drag and drop here"]}
            </Text>
            <input
              type="file"
              id="fileInput"
              accept="image/*"
              disabled={disabled}
              // multiple
              onChange={handleImageUpload}
              style={{ display: "none" }}
            />
          </label>
        )}
      </UploadContainer>
    </Container>
  );
};

export default ProductImages;
